module.exports = __webpack_public_path__ + "static/media/travel3.cee6a3f0.jpg";